import { ok } from "neverthrow";
import React from "react";
import {
  FormItemProvider,
  FormItemProviderProps,
} from "../../../FormItemProvider";
import { notEmptyInputToResultWrapper } from "../../../InputToResult";
import { Tons } from "../../../../../../domain/units/Tons";
import GenericNumberFormItemProvider from "../../_generic/number/GenericNumberFormItemProvider";
import { eqeqeq } from "../../../../../../shared/utils/equality";
import { unwrapValue } from "../../../../../../shared/utils/unwrapValue";

const fieldName = "Fresh Water ROB";

const FreshWaterFormItemProvider: FormItemProvider<Tons> = (props: FormItemProviderProps<Tons>) => (
  <GenericNumberFormItemProvider
    fieldName={fieldName}
    fieldType="FreshWater"
    addonAfter="tons"
    allowNegative={false}
    separateThousands={true}
    integersOnly={false}
    inputToResult={notEmptyInputToResultWrapper(fieldName, (input: number) => ok(new Tons(input)))}
    outputToInput={unwrapValue}
    inputsEqual={eqeqeq}
    {...props}
  />
);

export default React.memo(FreshWaterFormItemProvider);